import script from "./ProjectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectPage.vue?vue&type=script&setup=true&lang=js"

import "./ProjectPage.vue?vue&type=style&index=0&id=6d68dade&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d68dade"]])

export default __exports__